import { LogInterface } from '@@/LogViewer/types';

// Format ANSI logs string to log array with lazy span parsing
export function formatANSILogs(stripedLogs: string) {
  const lines = stripedLogs.split('\n');

  // Remove empty line at the end if it exists (common with logs ending with \n)
  const filteredLines =
    lines[lines.length - 1] === '' ? lines.slice(0, -1) : lines;

  if (filteredLines.length === 0) {
    return [];
  }

  const logs: LogInterface[] = filteredLines.map((line) => ({
    line,
    lowerLine: line.toLowerCase(),
    spans: [], // Empty spans - will be formatted on-demand in LogRow
  }));

  return logs;
}
